<!-- Task Create/Edit Offcanvas -->
<div #taskModal class="offcanvas offcanvas-end customeoff {{ show ? 'show' : '' }}" tabindex="-1"
  data-bs-backdrop="static">
  <div class="offcanvas-header">
    <h5 class="modal-title">
      {{ isEditMode ? 'Edit Task' : 'Create Task' }}
      <span *ngIf="isEditMode && selectedTaskCode" class="badge bg-light text-dark ms-2">{{ selectedTaskCode }}</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="taskForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row">
          <!-- Title -->
          <div class="col-12 mb-3">
            <label class="form-label">Title <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="title" placeholder="What needs to be done?"
              [class.is-invalid]="isFieldInvalid('title')" />
            <div class="invalid-feedback" *ngIf="isFieldInvalid('title')">Title is required</div>
          </div>

          <!-- Type -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Type</label>
            <ng-select [items]="typeOptions" bindValue="value" bindLabel="label" placeholder="Select type"
              class="select2" formControlName="task_type" [clearable]="true"></ng-select>
          </div>

          <!-- Priority -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Priority</label>
            <select class="form-select" formControlName="priority">
              <option *ngFor="let option of priorityOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <!-- Legacy category (only when an old row still uses it) -->
          <div class="col-xl-6 mb-3" *ngIf="showLegacyCategory">
            <label class="form-label">Category <small class="text-muted">(legacy)</small></label>
            <select class="form-select" formControlName="category">
              <option [ngValue]="null">None</option>
              <option *ngFor="let option of categoryOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <!-- Link -->
          <div class="col-12 mb-3">
            <label class="form-label d-block">Linked to</label>
            <div class="btn-group btn-group-sm link-switch mb-2" role="group">
              <input type="radio" class="btn-check" [name]="'link-' + uid" [id]="'link-none-' + uid"
                [checked]="linkType === 'none'" (change)="setLinkType('none')" />
              <label class="btn btn-outline-primary" [for]="'link-none-' + uid">None</label>
              <input type="radio" class="btn-check" [name]="'link-' + uid" [id]="'link-property-' + uid"
                [checked]="linkType === 'property'" (change)="setLinkType('property')" />
              <label class="btn btn-outline-primary" [for]="'link-property-' + uid">Property</label>
              <input type="radio" class="btn-check" [name]="'link-' + uid" [id]="'link-lead-' + uid"
                [checked]="linkType === 'lead'" (change)="setLinkType('lead')" />
              <label class="btn btn-outline-primary" [for]="'link-lead-' + uid">Lead</label>
            </div>
            <ng-select *ngIf="linkType === 'property'" [items]="properties.items" bindValue="value" bindLabel="label"
              placeholder="Search property by name" class="select2" formControlName="property_id"
              [typeahead]="properties.search$" [virtualScroll]="true" (scrollToEnd)="properties.scrollEnd()">
            </ng-select>
            <ng-select *ngIf="linkType === 'lead'" [items]="leads.items" bindValue="value" bindLabel="label"
              placeholder="Search lead by name / phone" class="select2" formControlName="related_id"
              [typeahead]="leads.search$" [virtualScroll]="true" (scrollToEnd)="leads.scrollEnd()">
            </ng-select>
          </div>

          <!-- Assignee -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Assignee</label>
            <ng-select [items]="users.items" bindValue="value" bindLabel="label" placeholder="Select assignee"
              class="select2" formControlName="assignee_id" [typeahead]="users.search$" [virtualScroll]="true"
              (scrollToEnd)="users.scrollEnd()" [clearable]="false">
            </ng-select>
            <small class="text-muted" *ngIf="!canAssign">You can only assign tasks to yourself.</small>
          </div>

          <!-- Status (edit only) -->
          <div class="col-xl-6 mb-3" *ngIf="isEditMode">
            <label class="form-label">Status</label>
            <select class="form-select" formControlName="status">
              <option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>

          <!-- Due date + planned window -->
          <div class="col-xl-4 col-md-6 mb-3">
            <label class="form-label">Due date</label>
            <input type="date" class="form-control" formControlName="due_date" />
          </div>
          <div class="col-xl-4 col-md-3 mb-3">
            <label class="form-label">Planned start</label>
            <input type="time" class="form-control" formControlName="planned_start" />
          </div>
          <div class="col-xl-4 col-md-3 mb-3">
            <label class="form-label">Planned end</label>
            <input type="time" class="form-control" formControlName="planned_end" />
          </div>

          <!-- Location -->
          <div class="col-12 mb-3">
            <label class="form-label">Location</label>
            <input type="text" class="form-control" formControlName="location_text"
              placeholder="Address or landmark (optional)" />
          </div>

          <!-- Description -->
          <div class="col-12 mb-3">
            <label class="form-label">Description</label>
            <textarea class="form-control" formControlName="description" rows="4"
              placeholder="Enter task description"></textarea>
          </div>

          <!-- Checklist -->
          <div class="col-12 mb-3">
            <label class="form-label">Checklist</label>
            <div class="d-flex align-items-center mb-1 checklist-item" *ngFor="let item of checklist; let i = index">
              <i class="fa fa-check-square-o text-muted me-2"></i>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="item.label"
                [ngModelOptions]="{ standalone: true }" (ngModelChange)="onChecklistLabelChange()" />
              <button type="button" class="btn btn-link btn-sm text-danger" (click)="removeChecklistItem(i)"
                title="Remove">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="input-group input-group-sm mt-2">
              <input type="text" class="form-control" placeholder="Add a checklist item" [(ngModel)]="newChecklistLabel"
                [ngModelOptions]="{ standalone: true }" (keydown.enter)="$event.preventDefault(); addChecklistItem()" />
              <button type="button" class="btn btn-outline-primary" (click)="addChecklistItem()">Add</button>
            </div>
          </div>

          <!-- Existing attachments (edit mode) -->
          <div class="col-12 mb-3" *ngIf="isEditMode && existingUploads.length > 0">
            <label class="form-label">Uploaded attachments</label>
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let file of existingUploads">
                <a [href]="file.upload_key" target="_blank" rel="noopener" class="text-truncate">
                  {{ file.original_name || 'Attachment' }}
                </a>
                <button type="button" class="btn btn-sm btn-outline-danger"
                  (click)="deleteExistingUpload(file.id)">Delete</button>
              </li>
            </ul>
          </div>

          <!-- Attachments -->
          <div class="col-12 mb-3">
            <label class="form-label">{{ isEditMode ? 'Add attachments' : 'Attachments' }}</label>
            <input type="file" class="form-control" [accept]="acceptAttr" multiple (change)="onFilesSelected($event)" />
            <small class="text-muted">Images, PDF, DOCX, CSV, Excel. Up to {{ maxFileSizeMb }}MB per file.</small>
            <ul class="list-group mt-2" *ngIf="selectedFiles.length > 0">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let file of selectedFiles; let i = index">
                <span class="text-truncate">{{ file.name }}</span>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFile(i)">Remove</button>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <button class="btn btn-primary ms-1 me-3" type="submit"
            [disabled]="taskForm.invalid || loadingService.isLoading()">
            {{ isEditMode ? 'Update Task' : 'Create Task' }}
          </button>
          <button class="btn btn-danger light me-1" type="button" (click)="close()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>

@if (show) {
<div class="offcanvas-backdrop fade show" (click)="close()"></div>
}
